import { Link, NavLink } from 'react-router-dom';
import { FaHeart } from "react-icons/fa";

import { IoMenu } from "react-icons/io5";
import { useState, useEffect } from "react";
import { FaLaptopHouse } from 'react-icons/fa';
import "./Navbar.css";
import { useSelector } from 'react-redux';
const Navbar =()=>{
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen]= useState(false);
  // const wishlistCount = useSelector((state) => state.wishlist?.wishlistItems?.length ||0);
  
  //const isGuest = !useSelector((state) => state.auth?.isLoggedIn); // Assuming you track login state
 
  const userId = useSelector((state) => state.auth?.userId); 
  const userCart = useSelector((state) => state.cart?.userCart || []);

  const guestCart = useSelector((state) => state.cart?.guestCart  || []);
  const userWishlist = useSelector((state) => state.wishlist?.userWishlist || []);
  const guestWishlist = useSelector((state) => state.wishlist?.wishlistItems || []);

  // ✅ Calculate wishlist count correctly
  const wishlistCount = userId
    ? userWishlist.length
    : guestWishlist.length; 
  // Fix: Get guest wishlist count from localStorage

  // Determine cart count based on user status
  const cartCount = userId
    ? userCart.reduce((sum, item) => sum + item.quantity, 0) // Sum quantities for logged-in users
    : guestCart.reduce((sum, item) => sum + item.quantity, 0); // Sum quantities for guests

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 350) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [wishlistCount,cartCount]);

  return (


      <nav
        className={` navbar navbar-expand-lg  ftco_navbar ftco-navbar-light  ${
          scrolled ? "scrolled" : "bg-transparent"
        }`}
       
      >
        <div className="container">
          <NavLink className="navbar-brand" to="/">
            <img src="/images/logosera.png" alt="Logo" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setMenuOpen(!menuOpen)}
          >
           <IoMenu/>Menu
          </button>
          <div className={`collapse navbar-collapse ${menuOpen ? "show": ""}`}>
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <NavLink className="nav-link" exact to="/" activeClassName="active">Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/shop" activeClassName="active">Shop</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about"  activeClassName="active">About</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/contact"  activeClassName="active">Contact</NavLink>
              </li>
              <li className="nav-item">
              {userId ? (
                <NavLink className="nav-link" to="/profile" activeClassName="active">
                  Account
                </NavLink>
              ) : (
                <NavLink className="nav-link" to="/login" activeClassName="active">
                  Login
                </NavLink>
              )}

               
              </li>
              <li className="nav-item cart">
                <NavLink className="nav-link" to="/cart">
                  <span className="icon icon-shopping_cart">
                
                  </span>
                  <span className="bag d-flex justify-content-center align-items-center">
                    <small>{cartCount}</small>
                  </span>
                </NavLink>
              </li>
              <li className="nav-item cart">
                <NavLink className="nav-link wishlist-link" to="/wishlist">
                  <span className="icon wishlist-icon-container">
                  <FaHeart className="wishlist-icon"/>
                  </span>
                  <span className="bag d-flex justify-content-center align-items-center">
                    <small>{wishlistCount}</small>
                  </span>
                </NavLink>
              </li>
             
            </ul>
          </div>
        </div>
      </nav>
    );
  };
  
  export default Navbar;
  

